module.exports = __webpack_public_path__ + "static/img/67094C_2_3_C_20200123_LC.a3839ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/67094C_2_3_C_20200123_LC.png
// module id = n/Dz
// module chunks = 0